import { Inject } from '@odinjs/odin';

import { APPLICATION_ROUTES, Endpoint, ToastServiceStipulator } from '@philips-emr/hpms-stipulator-commons';
import { FetchAPI, FormAPI, ToastNotificationAPI } from '@philips-emr/tws-components';
import { Value } from '@philips-emr/tws-core';
import Controller, { OnBeforeSubmit, OnCancel, OnClose, OnMount } from '@philips-emr/tws-core/lib/client';
import { MountEvent, SubmitEvent } from '@philips-emr/tws-core/lib/component/types';
import { HistoryService, HttpService, msg } from '@philips-emr/tws-core/lib/services';

import BaseController from './BaseController';

@Controller({ fragment: 'alterar-data-admissao' })
class AlteracaoDataAdmissaoController extends BaseController {

  @Inject('toast-notification')
  private toastForm: ToastNotificationAPI;
  @Inject('fetch-aberta')
  private fetchSolicAberta: FetchAPI;

  @OnMount({ target: 'form-data-admissao' })
  onMountForm(event: MountEvent): void {
    const apiForm = event.target as unknown as FormAPI;
    const { nrSeqBeneficiario, nrSeqContrato } = HistoryService.getCurrentRouteParams();
    void HttpService.get<Record<string, Value>>(Endpoint.GET.SOLIC_ALT_DATA_ADMISSAO_ABERTA, { nrSeqBeneficiario, nrSeqContrato }).then(response => {

      const { body: solicAberta } = response;
      if (!solicAberta) {
        this.executaConsultaDataAdmissaoAtual();
        return;
      }

      const { nrSeqSolicAlt } = solicAberta;
      this.context.set({ nrSeqSolicAlt });
      apiForm.setRecord(solicAberta);

    });
  }

  @OnBeforeSubmit({ target: 'form-data-admissao' })
  onSubmit(event: SubmitEvent): void {
    const { nrSeqBeneficiario, nrSeqContrato } = HistoryService.getCurrentRouteParams();
    const { dtAdmissaoNova } = event.record;
    const { nrSeqSolicAlt } = this.context.getBulkData();
    const body = { nrSeqBeneficiario, dtAdmissaoNova, nrSeqSolicAlt };
    HttpService.post(Endpoint.POST.SOLIC_ALT_DATA_ADMISSAO, { nrSeqBeneficiario, nrSeqContrato }, { body })
      .then(() => {

        ToastServiceStipulator.success(msg('stipuplator.alteracao.solicitada'));

        const { nrSeqGrupoContratoWeb, nrSeqContrato } = HistoryService.getCurrentRouteParams();
        HistoryService.push(APPLICATION_ROUTES.ALTERACAO_BENEFICIARIO, { nrSeqGrupoContratoWeb, nrSeqContrato });

      })
      .catch(() => {
        this.toastForm.setVisible(true);
      });
  }

  @OnCancel({ target: 'form-data-admissao' })
  onCancelForm(): void {
    const { nrSeqGrupoContratoWeb, nrSeqContrato } = HistoryService.getCurrentRouteParams();
    HistoryService.push(APPLICATION_ROUTES.ALTERACAO_BENEFICIARIO, { nrSeqGrupoContratoWeb, nrSeqContrato });
  }

  @OnClose({ target: 'toast-notification' })
  onCloseToast(): void {
    this.toastForm.setVisible(false);
  }

  private executaConsultaDataAdmissaoAtual(): void {
    const { nrSeqBeneficiario } = HistoryService.getCurrentRouteParams();
    this.context.set({ nrSeqBeneficiario });
    this.fetchSolicAberta.forceFetch();
  }

}
export default AlteracaoDataAdmissaoController;
